import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconChevronDoubleRight: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29289 2.29289C7.90237 2.68342 7.90237 3.31658 8.29289 3.70711L12.5858 8L8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289L9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L6.58579 8L2.29289 12.2929C1.90237 12.6834 1.90237 13.3166 2.29289 13.7071C2.68342 14.0976 3.31658 14.0976 3.70711 13.7071L8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289L3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289Z"
      />
    </svg>
  </IconStyled>
);

IconChevronDoubleRight.defaultProps = iconDefaultProps;
IconChevronDoubleRight.displayName = 'IconChevronDoubleRight';

export default IconChevronDoubleRight;
